import React, { useState, useEffect } from "react";

const RECORD_PASSWORD = process.env.REACT_APP_RECORD_PASSWORD || "gcc-record";
const STORAGE_KEY = "gcc-record-access";

function PasswordGate({ children }) {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const hasAccess = sessionStorage.getItem(STORAGE_KEY) === "true";
    if (hasAccess) {
      setIsAuthorized(true);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!RECORD_PASSWORD) {
      setIsAuthorized(true);
      return;
    }
    if (password === RECORD_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, "true");
      setIsAuthorized(true);
      setError("");
    } else {
      setError("Incorrect password. Please try again.");
    }
  };

  if (isAuthorized) {
    return children;
  }

  return (
    <div className="password-gate">
      <form className="password-form" onSubmit={handleSubmit}>
        <h2>Protected Area</h2>
        <p>Please enter the password to access this page.</p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoFocus
        />
        {error && <div className="password-error">{error}</div>}
        <button type="submit">Enter</button>
      </form>
    </div>
  );
}

export default PasswordGate;
